/**
 * 提供默认应用
 *
 */
import { HttpClient } from "./client";
import { BrowserXhr, HttpXhrBackend } from "./xhr";
import { Http } from "./http";
export var xhrHandler = new HttpXhrBackend(new BrowserXhr());
export var xhrClient = new HttpClient(xhrHandler);
export var http = new Http(xhrClient);